import PropTypes from 'prop-types'
import { AppBar, StyledToolbar } from './styles'

const AppHeader = ({ left, right, openDrawer = true }) => {
  return (
    <AppBar
      position='fixed'
      color='default'
      open={openDrawer}
    >
      <StyledToolbar>
        <div>
          {left}
        </div>
        <div>
          {right}
        </div>
      </StyledToolbar>
    </AppBar>
  )
}

export default AppHeader

AppHeader.defaultProps = {
  openDrawer: true,
  left: null,
  right: null
}

AppHeader.propTypes = {
  openDrawer: PropTypes.bool.isRequired,
  left: PropTypes.element,
  right: PropTypes.element
}
